export function isTokenExpired(token?: string | null): boolean {
  if (!token) {
    return false;
  }

  const payload = JSON.parse(atob(token.split(".")[1]));
  const exp = payload.exp * 1000;

  return Date.now() > exp;
}
